var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketingSpeaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_3462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.3335C12.5304 5.3335 13.0391 5.54421 13.4142 5.91928C13.7893 6.29436 14 6.80306 14 7.3335C14 7.86393 13.7893 8.37264 13.4142 8.74771C13.0391 9.12278 12.5304 9.3335 12 9.3335",
    stroke: "#232633",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 5.3335V12.6668C6.66669 12.8436 6.59645 13.0132 6.47142 13.1382C6.3464 13.2633 6.17683 13.3335 6.00002 13.3335H5.33335C5.15654 13.3335 4.98697 13.2633 4.86195 13.1382C4.73693 13.0132 4.66669 12.8436 4.66669 12.6668V9.3335",
    stroke: "#232633",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33346L11.016 2.82013C11.1036 2.74713 11.2103 2.70063 11.3234 2.68606C11.4365 2.6715 11.5514 2.68948 11.6547 2.7379C11.758 2.78631 11.8453 2.86316 11.9065 2.95943C11.9676 3.0557 12.0001 3.16741 12 3.28146V11.3855C12.0001 11.4995 11.9676 11.6112 11.9065 11.7075C11.8453 11.8038 11.758 11.8806 11.6547 11.929C11.5514 11.9774 11.4365 11.9954 11.3234 11.9809C11.2103 11.9663 11.1036 11.9198 11.016 11.8468L8 9.33346H2.66667C2.48986 9.33346 2.32029 9.26322 2.19526 9.1382C2.07024 9.01317 2 8.84361 2 8.66679V6.00013C2 5.82332 2.07024 5.65375 2.19526 5.52872C2.32029 5.4037 2.48986 5.33346 2.66667 5.33346H8",
    stroke: "#232633",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_3462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingSpeaker);
export default __webpack_public_path__ + "static/media/marketing-speaker.4804660f52eb8eee0fb75895aab2bf9f.svg";
export { ForwardRef as ReactComponent };